import * as React from 'react';
import { connect } from 'react-redux';

import PaymentsTableHead from './PaymentsTableHead';
import GetPaymentsInfo from './GetPaymentsInfo';
import LinearProgress from '@material-ui/core/LinearProgress';
import * as PaymentsCreators from '../../creators/paymentsInfoMountTab';

import EmptyData from '../../components/EmptyData/EmptyData';
import PaymentsInfoTotal from './PaymentsInfoTotal';
import PaymentsSubscription from '../../modules/PaymentSubscription/components/SubscriptionWrapper';

import State from '../../interfaces/states/State';
import PaymentsInfoData from '../../interfaces/PaymentsInfoData';

import './style.scss';

interface DispatchProps {
  paymentsInfoMountTab: () => void;
}

interface OwnProps {
  paymentsInfoData: PaymentsInfoData;
  isLoading: boolean;
  isError: boolean;
}

interface Props extends DispatchProps, OwnProps {}

function PaymentsInfo (props: Props) {

  React.useEffect(() => {
    props.paymentsInfoMountTab();
  }, []);
  
  return(
    <section className='payments-container' >
      {
        props.isLoading ?
          <div
            style={{ width: '96%', paddingLeft: '24px', paddingRight: '24px' }}
            className='loader-container' >
            <LinearProgress color='primary' />
          </div> :
          (
            props.paymentsInfoData.data.length > 0 ?
              <div>
                <PaymentsInfoTotal
                  totalPayments={props.paymentsInfoData.total_payments}
                  totalSum={props.paymentsInfoData.total_sum} />
                <div className='payments-table'>
                  <PaymentsTableHead />
                  <div
                    className='payments-table-scroll'
                  >
                    <GetPaymentsInfo paymentsInfoData={props.paymentsInfoData} />
                  </div>
                </div>
              </div>
              :
              <React.Fragment>
                <div className='sub-add-empty-data-wrapper'>
                  <div className='d-flex flex-column align-center justify-evenly payments-head-container sub-add-empty-data'>
                    <div className='payments-head'>
                      {'Subscription:'}
                    </div>
                    <PaymentsSubscription />
                  </div>
                </div>
                <div className='payments-empty-container d-flex align-center justify-center'>
                  <EmptyData
                    bigImageForTab
                    message='No data found for Payments info' />
                </div>
              </React.Fragment>
          )
      }
    </section>
  );
}

const mapStateToProps = (state: State) => {
  return {
    paymentsInfoData: state.paymentsInfo.paymentsInfoData,
    isLoading: state.paymentsInfo.isLoading,
    isError: state.paymentsInfo.isError,
  };
};

const mergeProps = (stateProps, dispatchProps, props) => {
  return {
    ...stateProps,
    paymentsInfoMountTab: dispatchProps.paymentsInfoMountTab,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    paymentsInfoMountTab: PaymentsCreators.paymentsInfoMountTab,
  }, mergeProps
)(React.memo(PaymentsInfo));
